import { Spinner, useBoolean, useDisclosure } from "@chakra-ui/react";
import { useContext } from "react";
import { BsDownload, BsFileEarmarkExcel, BsList } from "react-icons/bs";
import { ButtonIcon, ButtonLoading } from "../../../components/button/Button";
import Dialog from "../../../components/dialog/Dialog";
import { Table } from "../../../components/table/Table";
import { FeatureContext } from "../../../Context";
import { downloadAttachment, lang } from "../../../Utils";
import { downloadOrderDetails, getOrdersAttachment } from "../Services";


const DownloadAttachment = ({ data }) => {

  const [loader, setLoader] = useBoolean();
  const onClick = () => {
    setLoader.on();
    getOrdersAttachment({ url: data.documentUrl })
      .then(data => downloadAttachment(data?.data[0]))
      .finally(_ => setLoader.off());
  }
  return (!!data.documentUrl) ? <ButtonIcon type="button" variant="dark" size="sm" onClick={onClick}>
    {(loader) ? <Spinner size="sm" /> : <BsDownload />}
  </ButtonIcon> : null;
}

const TrackingLink = ({ data }) => {
  
  return (
      (!!data.trackingUrl) ? <><a href={data.trackingUrl} target="_blank">Tracking</a></> : null
  )
}

const SerialNumber = ({ data }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (!!data.serialNumber) ? <>
    <ButtonIcon variant="dark" size="sm" onClick={onOpen}>
      <BsList />
    </ButtonIcon>
    <Dialog isOpen={isOpen} onClose={onClose} title={lang('Serial Number')}>
      <div className="bf-serial-grid">
        {data.serialNumber.map((item, index) => <div key={`sn-${index}`}>
          <span>{item}</span>
        </div>)}
      </div>
    </Dialog>
  </> : null;
}

const Delivery = () => {
  const context = useContext(FeatureContext);

  return (<div>
    <div className="bf-actions bf-mb-10">
      <ButtonLoading
        disabled={!context?.details}
        callback={downloadOrderDetails}
        args={{ 
          orderId: context?.details?.slice(0, 1)[0]?.salesOrderNumber, 
          salesOrderItem : context?.detail?.salesOrderItem, 
          section: 'deliveryDetail' 
        }}
        icon={<BsFileEarmarkExcel />}
        label={lang('Excel')} />
    </div>
    <Table dataSet={context?.detail?.deliveryDetail} pagination={true} >
      <Table.Caption>{lang('Delivery List')}</Table.Caption>
      <Table.Header>
        <Table.Header.Column sortKey={"deliveryNoteNumber"} sortable={true}>{lang('Delivery Note')}</Table.Header.Column>
        <Table.Header.Column sortKey={"quantityDelivered"} sortable={true}>{lang('Delivery Qty')}</Table.Header.Column>
        <Table.Header.Column sortKey={"goodsMovementDate"} sortable={true}>{lang('Delivery date')}</Table.Header.Column>
        <Table.Header.Column sortKey={"incoterm"} sortable={true}>{lang('Incoterms')}</Table.Header.Column>
        <Table.Header.Column sortKey={"salesUnit"} sortable={true}>{lang('Sales Unit')}</Table.Header.Column>
        <Table.Header.Column sortKey={"trackingNumber"} sortable={true}>{lang('Tracking Number')}</Table.Header.Column>
        <Table.Header.Column >{lang('Serial Number')}</Table.Header.Column>
        <Table.Header.Column >{lang('Download Delivery')}</Table.Header.Column>
        <Table.Header.Column >{lang('Tracking Link')}</Table.Header.Column>
      </Table.Header>
      <Table.Body noDataMessage={lang('No Data available to display')}>
        <Table.Body.Text onClick={context.setDelivery} label={lang('Delivery Note')} field="deliveryNoteNumber" />
        <Table.Body.Text onClick={context.setDelivery} label={lang('Delivery Qty')} field="quantityDelivered" />
        <Table.Body.Date onClick={context.setDelivery} label={lang('Delivery date')} field="goodsMovementDate" />
        <Table.Body.Text onClick={context.setDelivery} label={lang('Incoterms')} field="incoterm" />
        <Table.Body.Text onClick={context.setDelivery} label={lang('Sales Unit')} field="salesUnit" />
        <Table.Body.Text onClick={context.setDelivery} label={lang('Tracking Number')} field="trackingNumber" />
        <Table.Body.Component label={lang('Serial Number')} rendercomponent={SerialNumber} />
        <Table.Body.Component label={lang('Download Delivery')} rendercomponent={DownloadAttachment} />
        <Table.Body.Component label={lang('Tracking Link')} rendercomponent={TrackingLink} />
      </Table.Body>
    </Table>
  </div>)
}

export default Delivery;